<template>
	<div class="c-did-you-mean">
		<ds-text
			html-element="h2"
			id="no-search-results-headline"
			text-type="heading-lg"
			class="c-did-you-mean__headline"
		>
			{{ headline }}
		</ds-text>
		<ds-text class="c-did-you-mean__text" html-element="p" text-style="regular" text-type="body-sm">
			{{ text }}
		</ds-text>

		<ul class="c-did-you-mean__list" v-if="items && items.length">
			<li v-for="item in items" :key="item" class="c-did-you-mean__item">
				<ds-button
					class="c-did-you-mean__button"
					@click="emit('didYouMeanSearch', item)"
					padding="padding-none"
					size="sm"
					variant="secondary-neutral"
				>
					&ldquo;{{ item }}&rdquo;
				</ds-button>
			</li>
		</ul>
	</div>
</template>

<script lang="ts" setup>
import { DsButton, DsText } from '@coloplast/design-system';

type Props = {
	headline: string;
	text: string;
	items?: Array<string>;
};

withDefaults(defineProps<Props>(), {});

const emit = defineEmits<(e: 'didYouMeanSearch', value: string) => void>();
</script>

<style lang="scss">
@import "multisite/styles/settings/settings";
@import "multisite/styles/tools/tools";

.c-did-you-mean {
	padding: 0;

	&__list {
		column-gap: ds-gap(4);
		display: flex;
		flex-wrap: wrap;
		list-style: none;
		margin: ds-space(8) 0 0 0;
		padding: 0;
	}

	&__headline {
		margin: 0 0 ds-space(4);
	}

	&__text {
		color: ds-color("fg", "muted");
		margin: 0;
	}

	&__item {
		margin: 0 0 ds-gap(5);
	}

	&__button {
		margin: 0;
	}
}
</style>
